import { render } from "./PostEditor.vue?vue&type=template&id=39eaba94&scoped=true"
import script from "./PostEditor.vue?vue&type=script&lang=ts"
export * from "./PostEditor.vue?vue&type=script&lang=ts"

import "./PostEditor.vue?vue&type=style&index=0&id=39eaba94&lang=scss&scoped=true"
import "./PostEditor.vue?vue&type=style&index=1&id=39eaba94&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-39eaba94"

export default script